export const mockupMenu = [
    {
        label: "Home",
        href: '#',
    },
    {
        label: "Dove siamo",
        href: '#'
    },
    {
        label: 'Prenota',
        href: '#'
    }
]

export const mockupMenuWithFoodMenu = [
    {
        label: "Home",
        href: '#',
    },
    {
        label: "Recensioni",
        href: '#'
    },
    {
        label: "Dove siamo",
        href: '#'
    },
    {
        label: "Menu",
        href: 'https://gleaming-quokka-256177.netlify.app/iframe.html?args=&id=components-menu--template&viewMode=story',
        class: 'a--pointer-event',
        target: '_self'
    }
]

export const mockupMenuWithMultiplePages = [
    {
        label: "Home",
        href: '#',
    },
    {
        label: "Ristorante",
        href: '#'
    },
    {
        label: "Specialità",
        href: '#'
    },
    {
        label: "Menu",
        href: 'https://gleaming-quokka-256177.netlify.app/iframe.html?args=&id=components-menu--template&viewMode=story',
        class: 'a--pointer-event',
        target: '_self'
    },
]

export const mockupMenuMultilangItalian = [
    {
        label: "Home",
        href: '#',
    },
    {
        label: "Ristorante",
        href: '#'
    },
    {
        label: "Specialità",
        href: '#'
    },
    {
        label: "Menu",
        href: 'https://gleaming-quokka-256177.netlify.app/iframe.html?args=&id=components-menu--template&viewMode=story',
        class: 'a--pointer-event',
        target: '_self'
    },
]

export const mockupMenuMultilangEnglish = [
    {
        label: "Home",
        href: '#',
    },
    {
        label: 'Restaurant',
        href: '#'
    },
    {
        label: "Specialties",
        href: '#'
    },
    {
        label: "Menu",
        href: 'https://gleaming-quokka-256177.netlify.app/iframe.html?args=&id=components-menu--template&viewMode=story',
        class: 'a--pointer-event',
        target: '_self'
    },
]